import store from '../../store/store';
import CallForBidsService from '../../services/CallForBidsService';

const state = {
    auctions:  [],
    auctions_archived: [],
    auctions_template: [],
    callForBids: [],
    callForBids_archived: [],
    callForBids_template: [],
    organizers: [],
    usageTypes: [],
};

const getters = {
    auctions() {
        return state.auctions;
    },
    callForBids() {
        return state.callForBids;
    },
    auctions_archived() {
        return state.auctions_archived;
    },
    callForBids_archived() {
        return state.callForBids_archived;
    },
    auctions_template() {
        return state.auctions_template;
    },
    callForBids_template() {
        return state.callForBids_template;
    },
    organizers() {
        return state.organizers;
    },
    usageTypes() {
        return state.usageTypes;
    },
};

const actions = {
    fetchAuctions({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.list(true, false, false)
            .then(data =>{
                commit("setAuctions", data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    fetchCallForBids({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.list(false, false, false)
            .then(data =>{
                commit("setCallForBids", data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    fetchArchivedAuctions({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.list(true, true, false)
            .then(data =>{
                commit("setAuctions_archived", data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    fetchTemplateAuctions({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.list(true, false, true)
            .then(data =>{
                commit("setAuctions_template", data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    fetchArchivedCallForBids({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.list(false, true, false)
            .then(data =>{
                commit("setCallForBids_archived", data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    fetchTemplateCallForBids({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.list(false, false, true)
            .then(data =>{
                commit("setCallForBids_template", data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    fetchOrganizers({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.fetchOrganizers()
            .then(data => {
                commit('setOrganizers', data.data);
                store.dispatch('loading/setLoading', false);
            });
    },
    delete({commit}, auctionId) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.delete(auctionId)
            .then(data => {
                store.dispatch("callForBids/fetchAuctions");
                store.dispatch('loading/setLoading', false);
            })
    },
    fetchSelectionLists({commit}) {
        store.dispatch('loading/setLoading', true);
        return CallForBidsService.fetchSelectionLists()
            .then(data => {
                commit('setUsageTypes', data.data.usageTypes);
                store.dispatch('loading/setLoading', false);
            });
    },
    clear({commit}) {
        commit('setAuctions', []);
        commit('setCallForBids', []);
        commit('setAuctions_archived', []);
        commit('setCallForBids_archived', []);
        commit('setAuctions_template', []);
        commit('setCallForBids_template', []);
        commit('setOrganizers', []);
        commit('setUsageTypes', []);
    }
}

const mutations = {
    setAuctions(state, auctions) {
        state.auctions = auctions;
    },
    setAuctions_archived(state, auctions) {
        state.auctions_archived = auctions;
    },
    setAuctions_template(state, auctions) {
        state.auctions_template = auctions;
    },
    setOrganizers(state, organizers) {
        state.organizers = organizers;
    },
    setCallForBids(state, callForBids) {
        state.callForBids = callForBids;
    },
    setCallForBids_archived(state, callForBids) {
        state.callForBids_archived = callForBids;
    },
    setCallForBids_template(state, callForBids) {
        state.callForBids_template = callForBids;
    },
    setUsageTypes(state, usageTypes) {
        state.usageTypes = usageTypes;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
